import Colors from 'enums/Colors';
import { propTypes } from 'react-bootstrap/esm/Image';
import styled from 'styled-components';

const PlanoAnual2025Styled = {
    Container: styled.div`
        font-family: 'Barlow', sans-serif;

        img {
            border-radius: 20px;
        }
    `,

    Title: styled.h1<{ blue?: boolean; fontSize?: string; maxFontSize?: string }>`
        color: ${props => (props.blue ? '#0e60e8' : '#000000')};
        font-weight: bold;
        font-family: 'Barlow', sans-serif;
        font-size: ${props => props.fontSize || '32px'};

        @media screen and (max-width: 1220px) {
            width: 100%;
        }

        @media screen and (max-width: 1080px) {
            font-size: ${props => props.maxFontSize} !important;
        }
    `,

    ContentColumn: styled.div<{isMaxWidth?: string}>`
        display: flex;
        flex-direction: column;
        gap: 22px;

        h1 {
            font-size: 24px;
            font-weight: bold;
        }

        img {
            width: 100%;

            @media screen and (max-width: 1280px){ 
                width: ${props => props.isMaxWidth || '100%'} !important;
            }
        }

        padding-right: 20px;
    `,
    Content: styled.div<{isDirectionRow?: boolean}>`
        display: flex;
        gap: 22px;

        h1 {
            font-size: 24px;
            font-weight: bold;
        }

        @media screen and (max-width: 1280px){
            flex-direction: ${props => (props.isDirectionRow ? 'row' : 'column')};
        }
    `,

    TitleYellow: styled.h1`
        color: ${Colors.Yellow};
        font-weight: bold;
        font-family: 'Barlow', sans-serif;
        font-size: 24px;
        text-transform: uppercase;
    `,

    CardWhite: styled.div`
        background-color: white;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
    `,
    CardWhite2: styled.div`
        background-color: #f7f4f3;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
    `,

    RowWrap: styled.div`
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        margin-bottom: 20px;
    `,

    CardYellow: styled.div`
        background-color: #f1bc40;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        padding: 20px;
        font-size: 18px;
        line-height: 24px;
        width: 100%;
        color: ${Colors.White};


        .metrica {
            display: flex;
            flex-direction: column;
            gap: 10px;
    

            span {
                font-size: 40px;
                font-weight: bold;
            }
        }
    `,

    CardBlue: styled.div`
        background-color: ${Colors.SolftBG2};
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        padding: 20px;
        font-size: 18px;
        line-height: 24px;
        width: 100%;
        color: ${Colors.White};


        .metrica {
            display: flex;
            flex-direction: column;
            gap: 10px;
    

            span {
                font-size: 40px;
                font-weight: bold;
            }
        }
    `,
    CardGray: styled.div`
        background-color: #dbdad8;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        padding: 20px;
        font-size: 18px;
        line-height: 24px;
        width: 100%;
        color: ${Colors.Blue};


        .metrica {
            display: flex;
            flex-direction: column;
            gap: 10px;
    

            span {
                font-size: 40px;
                font-weight: bold;
            }
        }
    `,

      TableWrapper: styled.div`
        width: 100%;
        overflow-x: auto;
    `,
};

export default PlanoAnual2025Styled;
